import { render, staticRenderFns } from "./EditNsrItemDialog.vue?vue&type=template&id=4948567e"
import script from "./EditNsrItemDialog.vue?vue&type=script&lang=js"
export * from "./EditNsrItemDialog.vue?vue&type=script&lang=js"
import style0 from "./EditNsrItemDialog.vue?vue&type=style&index=0&id=4948567e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports